import { Box } from '@wishket/design-system';
import { ComponentPropsWithRef, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface AuthorListCardListContainerProps
  extends ComponentPropsWithRef<'div'> {
  children: ReactNode;
}

const AuthorListCardListContainer = ({
  children,
  className,
  ...props
}: AuthorListCardListContainerProps) => {
  return (
    <Box
      className={twMerge(
        '-mx-5 flex gap-4 px-5',
        'desktop:-mx-9 desktop:-my-4 desktop:gap-6 desktop:px-9 desktop:py-4',
        'overflow-x-scroll scrollbar-hide',
        className
      )}
      {...props}
    >
      {children}
    </Box>
  );
};

export default AuthorListCardListContainer;
